module.exports = {
frame:{
    top_position: {
        y: 0,
        x: 0
    },
    left_position: {
        y: 20,
        x: 0
    },
    bottom_position: {
        y: 170,
        x: 0
    },
    right_position: {
        y: 20,
        x: 170
    }
}
};



//////////////////
// WEBPACK FOOTER
// ./cfg/frames-config.js
// module id = 26
// module chunks = 0